import {
  replacePlainTextToLinksPattern,
  replacePlainTextToLinksTemplate,
  splitTextDescriptionHTML
} from '../../../../utils/lookahead-common';
import { sanitizeString } from '../../GanttVisualization.helper';

export const createReadOnlyContent = (task, column, t) =>
  `<div>${splitTextDescriptionHTML(task, column, t)}</div>`;

export const createEditableContent = (task, columnName, t, column) => {
  const description = task[columnName]
    ? sanitizeString(task[columnName]).replace(
        replacePlainTextToLinksPattern,
        replacePlainTextToLinksTemplate
      )
    : '';

  return `
    <span>${description}</span>
    <div style="cursor: pointer;">
      ${splitTextDescriptionHTML(task, column, t)}
    </div>
  `;
};
